import {get, readable, writable} from "svelte/store";
import {mediaUrlStore} from "./app-store.js";
import {instantTranslate} from "./i18n/language-store.js";


export const docsStore = readable(
    {},
    (set) => {

        const mediaUrl = get(mediaUrlStore);
        const docs = (M.docs || []).map(doc => {
            doc.url = doc.fileUrl || (mediaUrl + M.tenantKey + '/_docs/' + doc.fileName);
            return doc;
        })

        set(docs);
        return () => {}
    });

export const privacyPolicyStore = writable({
    show: false,
    accepted: true,
    title: null,
    label: null,
    url: null,
});

privacyPolicyStore.update((privacyPolicy) => {

    privacyPolicy = (M.docs || []).find(x => x.docType === 'privacy-policy');

    if (privacyPolicy) {
        privacyPolicy.show = true;
        privacyPolicy.accepted = false;
        privacyPolicy.title = privacyPolicy.title || instantTranslate('docs.privacyPolicy');
        privacyPolicy.label = privacyPolicy.label || instantTranslate('docs.accept');
        privacyPolicy.url = privacyPolicy.fileUrl || (get(mediaUrlStore) + M.tenantKey + '/_docs/' + privacyPolicy.fileName);
    }
    else {
        privacyPolicy = {
            show: false,
            accepted: true
        };
    }

    return privacyPolicy;
});

export const acceptPrivacyPolicy = (accepted) => {
    privacyPolicyStore.update(x => {
        x.accepted = accepted;
        return x;
    });
}
